import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { DomainService } from '@services/domain.service';

const CHECK_INTERCEPTOR = new HttpContextToken<boolean>(() => true);
export function checkInterceptor() {
    return new HttpContext().set(CHECK_INTERCEPTOR, false);
}

const CHECK_DEFAULT_DOMAIN = new HttpContextToken<boolean>(() => false);
export function checkDefaultDomain() {
    return new HttpContext().set(CHECK_DEFAULT_DOMAIN, true);
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private readonly tokeService: TokenService, private readonly domainService: DomainService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        request = this.addToken(request);
        const authRequest = this.addDomain(request);
        return next.handle(authRequest);
    }

    addToken(request: HttpRequest<unknown>) {
        if (!request.context.get(CHECK_INTERCEPTOR)) {
            return request;
        }
        const token = this.tokeService.getToken();
        if (!token) {
            return request;
        }
        const auth = request.clone({
            setHeaders: {
                token,
            },
        });
        return auth;
    }

    addDomain(request: HttpRequest<unknown>) {
        if (!request.context.get(CHECK_INTERCEPTOR)) {
            return request;
        }

        let domain = this.domainService.getDomain() ?? 'ALL';
        if (request.context.get(CHECK_DEFAULT_DOMAIN)) {
            domain = 'ALL';
        }

        return request.clone({
            setHeaders: {
                domain,
            },
        });
    }
}
